module.exports = __webpack_public_path__ + "32d75aa25638c1534cb3375e96e23677.svg";